import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { cn } from "@/lib/utils";

export const CitySelect = ({ cities, value, onChange, allLabel = "Semua kota", testId = "city-select", className, required }) => (
  <Select value={value || (required ? undefined : "semua")} onValueChange={(v) => onChange(v === "semua" ? "" : v)}>
    <SelectTrigger data-testid={testId} className={cn("h-11 rounded-xl border-stone-200 bg-white", className)}>
      <SelectValue placeholder="Pilih kota" />
    </SelectTrigger>
    <SelectContent className="max-h-72 rounded-xl">
      {!required && <SelectItem value="semua" data-testid={`${testId}-option-semua`}>{allLabel}</SelectItem>}
      {cities.map((c) => (
        <SelectItem key={c.slug} value={c.slug} data-testid={`${testId}-option-${c.slug}`}>{c.name}</SelectItem>
      ))}
    </SelectContent>
  </Select>
);
